import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LanguageTabs extends Component {
  state = {
    activeIndex: this.props.defaultIndex || 0,
  };

  render() {
    const { activeIndex } = this.state;
    const { children } = this.props;
    const tabs = React.Children.map(children, (child, index) => (
      <span className={`tab pl-2 flex items-center cursor-pointer font-semibold text-xxs rounded-t ${activeIndex === index ? 'active' : ''}`} onClick={() => this.setState({ activeIndex: index })}>
        {child.props.label}
      </span>
    ));

    return (
      <div className="tabs-container">
        <div className="flex">{tabs}</div>
        {children[activeIndex]}
      </div>
    );
  }
}

LanguageTabs.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default LanguageTabs;
